import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';
import { LeftSideMenuModule } from '@app/modules/left-side-menu/left-side-menu.module';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';

import { AppContainerComponent } from '.';
import { ManageChannelsModule } from '@app/modules/manage-channels/manage-channels.module';
import { AppContainerRoutingModule } from './app-container-routing.module';
import { PostAssignItemsModule } from '@app/modules/feed/post-assign-items-dialog/post-assing-items-dialog.module';
import { AddArticleModule } from '@app/shared/dialogs/add-article/add-article.module';

@NgModule({
    declarations: [AppContainerComponent],
    imports: [
        CommonModule,
        SharedModule,
        ManageChannelsModule,
        AppContainerRoutingModule,
        LeftSideMenuModule,
        PostAssignItemsModule,
        AddArticleModule,
        MatSidenavModule,
        MatIconModule,
        MatButtonModule,
        MatToolbarModule,
    ],
    exports: [AppContainerComponent],
})
export class AppContainerModule {}
